const Roles = {
    T : ["Editor","Captain", "Coach", "Manager", "Player", "Referee", "Staff"],
    L: ["Editor","President", "Vice President", "Secretary", "Governing Body", "Council Memeber", "Public Relations", "Finance", "General Administration", "Executive Committee", "Chairman", "Vice Chairman"],
    C: ["Editor","Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"],
    I: ["Editor","Head of sport department", "Assistant head of sport department", "Offer of sport department", "Director of sport department", "Assistant director of sport department", "Officer of a sport", "Head coach", "Assistant head coach", "Team captian", "Team player", "Student"]
}

export default Roles;


// WEBPACK FOOTER //
// ./src/components/Roles.js